var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.data)?_c('cam-view',{ref:"camView",staticStyle:{"width":"100%"},attrs:{"cam":_vm.data,"with-resize":false,"with-hd":false,"layout":"col","compact":"","hide-controls":_vm.hideControls}}):_vm._e(),_c('div',{staticClass:"back-app__offset"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }